// "Open EMR" — opens the doctor's external EMR sign-in (Doximity) in a new tab. Per Thomas/FB this
// replaces the prior Healthie hand-off; same June-12 model: just a link — no SSO, no sign-in, no
// integration. The full patient record lives in the EMR, never in Champion Care (D5/D10). Reusable
// by doctor mobile (WF15).
import { Btn } from "@championcare/ui";

// External EMR sign-in — opens in a new tab. A real <button> (not an anchor) so it keeps the
// primary variant's own text colour and isn't caught by the portal's `.doctor-app a` link styling.
export const EMR_LOGIN_URL = "https://auth.doximity.com/sessions/login";

export function EmrHandoff({ patientRef }: { patientRef?: string | null }) {
  return (
    <div className="handoff">
      <div className="handoff__copy">
        <strong>Patient chart</strong>
        <p className="muted">
          The full patient record and all documentation live in the EMR.
          {patientRef ? (
            <>
              {" "}
              Patient ref <span className="mono">{patientRef}</span>.
            </>
          ) : null}
        </p>
      </div>
      <Btn
        as="button"
        variant="primary"
        onClick={() => window.open(EMR_LOGIN_URL, "_blank", "noopener,noreferrer")}
      >
        Open EMR
      </Btn>
    </div>
  );
}
